<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-hat-3"
                    placeholder="Nombre"
                    name="Nombre"
                    :rules="{ required: true }"
                    v-model="nombre"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    v-model="email"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    placeholder="password"
                    type="password"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    v-model="password"
                  >
                  </base-input>
                  <div class="text-muted">Privilegios:</div>
                  <b-row class="my-4">
                    <b-col cols="12">
                      <span>Super usuario: </span>
                      <b-form-radio-group
                        id="radio-group-1"
                        v-model="superUsuario"
                        :options="[
                          { text: 'Si', value: 1 },
                          { text: 'No', value: 2 },
                        ]"
                        name="radio-options"
                      ></b-form-radio-group>
                    </b-col>
                  </b-row>
                  <b-form-group v-if="superUsuario == 2">
                    <template v-for="element in optionsCurso">
                      <b-form-checkbox
                        :key="Math.random()"
                        v-model="element.selected"
                      >
                        <span>{{ element.text }}</span>
                      </b-form-checkbox>

                      <b-form-checkbox-group
                        :key="element.id"
                        v-model="element.selectedValues"
                        :options="element.value"
                        name="flavors"
                        class="ml-4"
                        stacked
                      ></b-form-checkbox-group>
                    </template>
                  </b-form-group>

                  <div class="text-center">
                    <b-button type="submit" variant="primary" class="mt-4"
                      >Crear Usuario</b-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from '@/directives/axios.js';
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  name: "register",
  data() {
    return {
      superUsuario: null,
      optionsCurso: undefined,
      cursoSelected: null,
      selecion: [],
      nombre: "",
      email: "",
      password: "",
    };
  },
  created() {
    this.cargaCursosGruposCatequistas();
  },
  methods: {
    cargaCursosGruposCatequistas() {
      this.optionsCurso = this.$store.getters.getCursosGruposCatequistas.map(
        (element) => {
          return {
            text: element.nombre,
            value: element.grupos.map((grupo) => {
              return {
                text: grupo.nombre_grupo,
                value: grupo.id,
                idCurso: element.id,
              };
            }),
            id: element.id,
          };
        }
      );
    },
    onSubmit() {
      loader.open();
      var privilegios = "";
      if (this.superUsuario == 1) {
        privilegios = "SU";
      } else {
        var privilegiosInd = "";
        this.optionsCurso.forEach((element) => {
          if (element.selected) {
            if (privilegiosInd.length > 0) {
              privilegiosInd = privilegiosInd + "/";
            }
            privilegiosInd = privilegiosInd + `C|${element.id}_W`;
          } else {
            if (
              element.selectedValues &&
              Array.isArray(element.selectedValues)
            ) {
              element.selectedValues.forEach((element2) => {
                if (privilegiosInd.length > 0) {
                  privilegiosInd = privilegiosInd + "/";
                }
                privilegiosInd = privilegiosInd + `G|${element2}_W`;
              });
            }
          }
        });
        // C|4-W/C|3-W/C|1-W/C|2-W
        privilegios = privilegiosInd;
      }
      var data = {
        name: this.nombre,
        email: this.email,
        password: this.password,
        privilegios: privilegios,
      };
      
      axios({
        method: "POST",
        url: `/register`,
        withCredentials: true,
        data: data,
      })
        .then((data) => {
          this.superUsuario = null,
          this.optionsCurso = undefined,
          this.cursoSelected = null,
          this.selecion = [],
          this.nombre = "",
          this.email = "",
          this.password = "",
          loader.close();
          swal
            .fire({
              title: `Datos Guardados Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            });
        })
        .catch((erro) => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un error inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
  },
};
</script>
<style></style>
